module.exports = __webpack_public_path__ + "static/media/Complete.9277d241.svg";